import isEmpty from "./helpers/isEmpty";
import NewsModel from "./models/NewsModel";
import PagedResponse from "./models/PagedResponse";
import newsFetch from "./api/newsFetch";

/**
 * Init insights container
 *
 * @param {string} htmlContainerId
 * @param {string} htmlInsightsListId
 * @param {string} htmlFilterButtonId
 * @param {string} htmlCategorySelectId
 * @returns
 */
const initInsightsContainer = (
  htmlContainerId,
  htmlInsightsListId,
  htmlFilterButtonId,
  htmlCategorySelectId
) => {
  const container = document.getElementById(htmlContainerId);
  if (!container) return;

  fetchData(container, htmlInsightsListId);

  $(document).ready(() => {
    $("#loadMorePress").on("click", function (e) {
      e.preventDefault();

      if (window.currentPageNumber < window.lastPageNumber) {
        getDataPress(window.currentPageNumber + 1, PerPageQuery);
      }

      if (window.currentPageNumber == window.lastPageNumber) {
        $("#loadMorePress").text("No more content").addClass("noContent");
      }
    });

    $(`#${htmlFilterButtonId}`).on("click", (e) => {
      e.preventDefault();
      const categorySelect = document.getElementById(htmlCategorySelectId);
      if (categorySelect) {
        container.dataset.page = 1;
        container.dataset.categoryId = categorySelect.value;
        fetchData(container, htmlInsightsListId);
      }
    });
  });
};

/**
 * Load insights content.
 *
 * @param {HTMLElement} container - container containing html data variables
 * @param {string} htmlInsightsListId - id of html container containing insights cards
 */
const fetchData = async (container, htmlInsightsListId) => {
  const {
    protocol,
    host,
    apiSuffix,
    folderId,
    page,
    perPage,
    categoryId,
    listingPageId,
  } = container.dataset;

  const response = await newsFetch(
    protocol,
    host,
    apiSuffix,
    folderId,
    categoryId,
    page,
    perPage,
    listingPageId
  );

  if (response.success) {
    const data = !isEmpty(response.data) ? response.data : new PagedResponse();
    printDataPress(container, data, htmlInsightsListId);
  } else {
    printDataPress(container, new PagedResponse(), htmlInsightsListId);
  }
};

/**
 *
 * @param {HTMLElement} container - container containing html data variables
 * @param {PagedResponse} pagedResponse - class model of paged response
 * @param {string} htmlInsightsListId - id of html container containing insights cards
 */
function printDataPress(container, pagedResponse, htmlInsightsListId) {
  const insightsListContainer = document.getElementById(htmlInsightsListId);
  if (!insightsListContainer) return;

  if (container.dataset.perRow) {
    insightsListContainer.style.setProperty(
      "--perRow",
      container.dataset.perRow
    );
  }

  let html = "";
  if (pagedResponse && pagedResponse.results && pagedResponse.results.length) {
    pagedResponse.results.forEach((element) => {
      if (element instanceof NewsModel) {
        html += element.generateInsightCard();
      }
    });
  } else {
    html = pagedResponse.generateNoResults(container.dataset.perRow, 4);
  }
  insightsListContainer.innerHTML = html;

  const pagination = pagedResponse.createPagination(
    insightsListContainer.nextElementSibling,
    container,
    () => fetchData(container, htmlInsightsListId)
  );
  insightsListContainer.insertAdjacentElement("afterend", pagination);
}

initInsightsContainer(
  "insightsContainer",
  "insightsGeneralList",
  "insightsFilterButton",
  "insightsCategorySelect"
);

export default initInsightsContainer;
